"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HAZARD_CONSTRAINTS = void 0;
;
exports.HAZARD_CONSTRAINTS = [
    'erosionOceanCount',
    'removeDustStormsOceanCount',
    'severeErosionTemperature',
    'severeDustStormOxygen',
];
//# sourceMappingURL=IAresData.js.map